import axios from "axios";
import { nextTick } from 'vue'

const http = axios.create({
    headers: {
        "Content-type": "application/json",
    }
})

http.interceptors.response.use(
    (response) => {
        if (response.status === 200) {
            return response;
        } else {
            return Promise.reject({ messages: ["got errors"] });
        }
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            //location.href = "/login";
            nextTick(() => {
                window.emitter.emit('display_login')
            })
            return Promise.reject(error.response);
        }
        else if (error.response && error.response.status === 302) {
            location.href = "/login";
        } else if (error.response && error.response.status === 500) {
            return Promise.reject(error.response);
        } else return Promise.reject(error);
    }
);

export default http